import { render, staticRenderFns } from "./ResidentialLayout.vue?vue&type=template&id=03036e45&scoped=true&"
import script from "./ResidentialLayout.vue?vue&type=script&lang=js&"
export * from "./ResidentialLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResidentialLayout.vue?vue&type=style&index=0&id=03036e45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03036e45",
  null
  
)

export default component.exports